import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { get } from '@eika-infrastruktur/request';
import { MediumCenteredContainer } from '@eika/engine-view';
import { LinkPanel } from '@eika/link-panel';
import { Loader } from '@eika/loader';

import { changeLBSBank, showLBSBankSelect } from '../actions';
import { actionTypes, DispatchWithState, StringKeyValue } from '../actions/types';
import LBSBankSelectComponent from '../components/LBSBankSelect/LBSBankSelectComponent';
import CustomAppTypes from '../config/customAppTypes';
import { LbsRelasjonResponse } from '../generated-types';
import { AppState } from '../reducers';
import { ContextReducer } from '../reducers/context';
import { LbsReducer } from '../reducers/lbs';

interface Props {
    action: {
        changeLBSBank: (bankregnr: string) => DispatchWithState;
        showLBSBankSelect: (show: boolean) => void;
    };
    context: ContextReducer;
    text: StringKeyValue;
    lbs: LbsReducer;
}

const LBSBankSelect = (props: Props) => {
    const { text, action, lbs } = props;

    const { data, isLoading, isSuccess } = useQuery({
        queryKey: ['LbsRelations'],
        queryFn: async (): Promise<LbsRelasjonResponse> => {
            return get(`${actionTypes.RESOURCE_PATH}/kort/lbs`);
        },
    });
    useEffect(() => {
        if (!CustomAppTypes.isLbs(props.context)) action.showLBSBankSelect(false);
        if (
            data &&
            data.lbsBankregnrs.length === 1 &&
            lbs.lbsBanks.find((b) => b.value === data.lbsBankregnrs[0].value)
        ) {
            action.changeLBSBank(data.lbsBankregnrs[0].value);
            action.showLBSBankSelect(false);
        }
    }, [action, data, lbs.lbsBanks, props.context]);

    const linkPanels = data?.lbsBankregnrs.map((bankReg) => {
        const matchingBank = lbs.lbsBanks.find((bank) => bank.value === bankReg.value);

        if (matchingBank) {
            const { text, value } = matchingBank;
            return <LinkPanel key={value} title={text} url="/#/" onClick={() => action.changeLBSBank(value)} />;
        }

        return null;
    });
    if (isLoading) return <Loader key={text.loadingUser} />;

    return (
        <MediumCenteredContainer>
            {isSuccess && linkPanels && linkPanels.length > 1 ? (
                <>
                    <h4>{text.lbsBankSelectMultipleRelations}</h4>
                    <div className="component-group">{linkPanels}</div>
                </>
            ) : (
                <>
                    <h1>{text.lbsBankSelectTitle}</h1>
                    <LBSBankSelectComponent text={text} lbs={lbs} />
                </>
            )}
        </MediumCenteredContainer>
    );
};

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    context: state.context,
    lbs: state.lbs,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    action: bindActionCreators(
        {
            changeLBSBank,
            showLBSBankSelect,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(LBSBankSelect);
